import React from 'react';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography from 'src/app/atoms/Typography/Typography';
import { IPricingCard } from 'src/hooks/usePricingCards';
import { PriceBlockContainer } from './PriceBlock.styles';
import Button from 'atoms/Button/Button';
import Grid from 'atoms/Layout/Grid/Grid';
import { ColorModeBorderPropKeys } from 'styles/colors';

interface PriceBlockProps
  extends Pick<IPricingCard, 'planTitle' | 'price' | 'supportingText' | 'callToAction' | 'pricePeriodText'> {
  align?: 'left' | 'center';
  minHeight?: number;
  hidePlanTitle?: boolean;
  priceBlockBorder?: ColorModeBorderPropKeys;
}

const PriceBlock = ({
  price,
  planTitle,
  align,
  supportingText,
  callToAction,
  minHeight,
  pricePeriodText = 'per month',
  hidePlanTitle = false,
  priceBlockBorder = 'border-secondary',
}: PriceBlockProps): JSX.Element => (
  <PriceBlockContainer
    direction='column'
    justify='space-between'
    align={align === 'left' ? 'flex-start' : 'center'}
    padding='spacing-4xl'
    gap='spacing-xl'
    className='price-block'
    $minHeight={minHeight}
    $priceBlockBorder={priceBlockBorder}
  >
    <Stack
      direction='column'
      justify={align === 'left' ? 'flex-start' : 'center'}
      align={align === 'left' ? 'flex-start' : 'center'}
      gap='spacing-xl'
    >
      {!hidePlanTitle && (
        <Typography
          text={planTitle}
          skipTranslation={true}
          type='paragraph'
          size='xl'
          fontWeight='font-weight-semibold'
          textAlign={align}
        />
      )}
      {price ? (
        <Stack
          justify={align === 'left' ? 'flex-start' : 'center'}
          align={align === 'left' ? 'flex-end' : 'center'}
          direction={align === 'left' ? 'row' : 'column'}
          gap='spacing-xs'
        >
          <Typography
            text={`$${price}`}
            type='heading'
            size='md'
            fontWeight='font-weight-semibold'
          />
          <Typography
            text={pricePeriodText}
            type='paragraph'
            size='md'
            fontWeight='font-weight-medium'
            color='text-tertiary'
            className='period'
            whiteSpace='nowrap'
          />
        </Stack>
      ) : (
        <Typography
          text='Request Pricing'
          type='paragraph'
          size='xl'
        />
      )}
      <Typography
        text={supportingText}
        type='paragraph'
        size='md'
        color='text-tertiary'
      />
    </Stack>
    {callToAction && (
      <Grid totalColumns={1}>
        <Stack>
          <Button
            href={callToAction.href}
            variant={callToAction.variant || 'primary'}
            size='xl'
          >
            {callToAction.text}
          </Button>
        </Stack>
      </Grid>
    )}
  </PriceBlockContainer>
);

export default PriceBlock;
